import { render, staticRenderFns } from "./SpoiledShareButton.vue?vue&type=template&id=17b4bbbe&scoped=true&"
import script from "./SpoiledShareButton.vue?vue&type=script&lang=js&"
export * from "./SpoiledShareButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4bbbe",
  null
  
)

export default component.exports